import { render, staticRenderFns } from "./CollectionPage.vue?vue&type=template&id=ab16490a&scoped=true&"
import script from "./CollectionPage.vue?vue&type=script&lang=js&"
export * from "./CollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPage.vue?vue&type=style&index=0&id=ab16490a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab16490a",
  null
  
)

export default component.exports